import { ContentFeed, ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
export { default } from "./TextView.vue";

export const selector = (feed: ContentFeed): boolean => {
  return feed.type === ContentFeedTypeEnum.RICH_TEXT;
};
